export const descriptiveTextRubrics = [
	{
		name: "Beskrivande text",
		grade: "åk3",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Sinnesintryck och detaljer",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Använder två sinnen 2) Flera adjektiv 3) Några detaljer",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder ett sinne 2) Några adjektiv 3) En detalj",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Beskriver något 2) Något adjektiv",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Beskrivningar 2) Adjektiv",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig miljöbeskrivning 2) Enkel personbeskrivning 3) Viss stämning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Beskriver miljö 2) Nämner person",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Nämner miljö eller person",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Miljö 2) Person",
					},
				],
			},
			{
				name: "Struktur och fokus",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tre stycken 2) Röd tråd 3) Tydlig början och slut",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Två stycken 2) Viss ordning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Början och slut",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Struktur",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Olika meningar 2) Stor bokstav och punkt 3) Stavning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Enkla meningar 2) Ofta stor bokstav och punkt",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Går att förstå",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Förståelse",
					},
				],
			},
		],
	},
	{
		name: "Beskrivande text",
		grade: "åk4",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Sinnesintryck och detaljer",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Använder tre sinnen 2) Många adjektiv 3) Flera detaljer 4) Enkel liknelse",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder två sinnen 2) Flera adjektiv 3) Några detaljer",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Använder ett sinne 2) Några adjektiv",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sinnesintryck 2) Adjektiv",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig miljöbeskrivning 2) Enkel personbeskrivning 3) Viss stämning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Beskriver miljö 2) Nämner person",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Beskriver något av miljö eller person",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Miljö 2) Person",
					},
				],
			},
			{
				name: "Struktur och fokus",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tre-fyra stycken 2) Röd tråd 3) Tydlig början och slut",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Två-tre stycken 2) Viss ordning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Minst två stycken",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Stycken",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Varierande meningar 2) Skiljetecken 3) Stavning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Olika meningar 2) Oftast skiljetecken",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkla meningar 2) Ibland skiljetecken",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Meningar 2) Skiljetecken",
					},
				],
			},
		],
	},
	{
		name: "Beskrivande text",
		grade: "åk5",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Sinnesintryck och detaljer",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tre-fyra sinnen 2) Varierade adjektiv 3) Många detaljer 4) Liknelser",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Två sinnen 2) Flera adjektiv 3) Detaljer",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ett-två sinnen 2) Några adjektiv",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sinnesintryck 2) Adjektiv",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Utvecklad miljöbeskrivning 2) Tydlig personbeskrivning 3) Stämning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig miljö 2) Enkel person 3) Viss stämning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Beskriver miljö 2) Nämner person",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Miljö 2) Person",
					},
				],
			},
			{
				name: "Struktur och fokus",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fyra stycken 2) Röd tråd 3) Inledning och avslutning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tre stycken 2) Viss ordning 3) Början och slut",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Två-tre stycken 2) Enkel ordning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Stycken 2) Ordning",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Varierat språk 2) Skiljetecken 3) Stavning 4) Styckemarkeringar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Oftast skiljetecken 3) Stycken",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkelt språk 2) Ibland skiljetecken",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydlighet 2) Skiljetecken",
					},
				],
			},
		],
	},
	{
		name: "Beskrivande text",
		grade: "åk6",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Sinnesintryck och detaljer",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tre-fyra sinnen effektivt 2) Träffsäkra adjektiv 3) Målande detaljer 4) Kreativa liknelser",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Två-tre sinnen 2) Beskrivande adjektiv 3) Flera detaljer",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ett-två sinnen 2) Enkla adjektiv 3) Några detaljer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sinnesintryck 2) Adjektiv 3) Detaljer",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Levande miljöbeskrivning 2) Nyanserad personbeskrivning 3) Stark stämning 4) Konsekvent perspektiv",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad miljöbeskrivning 2) Tydlig personbeskrivning 3) Viss stämning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel miljöbeskrivning 2) Enkel personbeskrivning 3) Försök till stämning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Miljöbeskrivning 2) Personbeskrivning 3) Stämning",
					},
				],
			},
			{
				name: "Struktur och fokus",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydligt fokus 2) Fyra-fem stycken 3) Logisk disposition 4) Bra övergångar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Huvudsakligt fokus 2) Tre-fyra stycken 3) Enkel disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkelt fokus 2) Minst tre stycken 3) Början-mitten-slut",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fokus 2) Styckeindelning 3) Struktur",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Varierat språk 2) Precisa ordval 3) Effektivt bildspråk 4) Korrekt meningsbyggnad",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Beskrivande ordval 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Enkla ordval 3) Mestadels korrekt",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Beskrivande ord 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Beskrivande text",
		grade: "åk7",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Sinnesintryck och detaljer",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tre-fyra sinnen effektivt 2) Precisa adjektiv och verb 3) Levande detaljer 4) Kreativa liknelser",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Två-tre sinnen 2) Beskrivande adjektiv 3) Flera detaljer",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ett-två sinnen 2) Enkla adjektiv 3) Några detaljer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sinnesintryck 2) Adjektiv 3) Detaljer",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Levande miljöbeskrivning 2) Nyanserad personbeskrivning 3) Stark stämning 4) Konsekvent perspektiv",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad miljöbeskrivning 2) Tydlig personbeskrivning 3) Viss stämning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel miljöbeskrivning 2) Enkel personbeskrivning 3) Försök till stämning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Miljöbeskrivning 2) Personbeskrivning 3) Stämning",
					},
				],
			},
			{
				name: "Struktur och fokus",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydligt fokus 2) Fyra-fem stycken 3) Logisk disposition 4) Bra övergångar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Huvudsakligt fokus 2) Tre-fyra stycken 3) Enkel disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkelt fokus 2) Minst tre stycken 3) Början-mitten-slut",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fokus 2) Styckeindelning 3) Struktur",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Varierat språk 2) Precisa ordval 3) Effektivt bildspråk 4) Korrekt meningsbyggnad",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Beskrivande ordval 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Enkla ordval 3) Mestadels korrekt",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Beskrivande ord 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Beskrivande text",
		grade: "åk8",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Sinnesintryck och detaljer",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fyra sinnen effektivt 2) Precisa och varierade adjektiv 3) Målande detaljer 4) Avancerade liknelser",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tre sinnen 2) Beskrivande adjektiv 3) Flera detaljer 4) Enkel liknelse",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Två sinnen 2) Enkla adjektiv 3) Några detaljer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sinnesintryck 2) Adjektiv 3) Detaljer",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Målande miljöbeskrivning 2) Djup personbeskrivning 3) Övertygande stämning 4) Effektivt perspektiv",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad miljöbeskrivning 2) Tydlig personbeskrivning 3) Genomgående stämning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel miljöbeskrivning 2) Grundläggande personbeskrivning 3) Viss stämning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Miljöbeskrivning 2) Personbeskrivning 3) Stämning",
					},
				],
			},
			{
				name: "Struktur och fokus",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Genomgående fokus 2) Fem-sex stycken 3) Effektiv disposition 4) Smidiga övergångar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt fokus 2) Fyra-fem stycken 3) Logisk disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Visst fokus 2) Tre-fyra stycken 3) Enkel disposition",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fokus 2) Styckeindelning 3) Disposition",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Precist språk 2) Träffsäkra ordval 3) Kreativt bildspråk 4) Välutvecklad meningsbyggnad",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Varierade ordval 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Enkla ordval 3) Mestadels korrekt",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Variation 3) Korrekthet",
					},
				],
			},
		],
	},

	{
		name: "Beskrivande text",
		grade: "åk9",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Sinnesintryck och detaljer",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fyra-fem sinnen effektivt 2) Precisa och kreativa adjektiv 3) Genomarbetade detaljer 4) Särskilt träffsäkra liknelser",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tre-fyra sinnen 2) Träffsäkra adjektiv 3) Flera detaljer 4) Fungerande liknelser",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Två-tre sinnen 2) Beskrivande adjektiv 3) Några detaljer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sinnesintryck 2) Adjektiv 3) Detaljer",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Genomarbetad miljöbeskrivning 2) Komplex personbeskrivning 3) Genomgående stämning 4) Medvetet perspektivval",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad miljöbeskrivning 2) Nyanserad personbeskrivning 3) Tydlig stämning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel miljöbeskrivning 2) Grundläggande personbeskrivning 3) Viss stämning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Miljöbeskrivning 2) Personbeskrivning 3) Stämning",
					},
				],
			},
			{
				name: "Struktur och fokus",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Genomgående tydligt fokus 2) Sex-sju stycken 3) Särskilt effektiv disposition 4) Eleganta övergångar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt fokus 2) Fem-sex stycken 3) Genomtänkt disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Visst fokus 2) Fyra stycken 3) Fungerande disposition",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fokus 2) Styckeindelning 3) Disposition",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Mycket precist språk 2) Särskilt träffsäkra ordval 3) Avancerat bildspråk 4) Komplex meningsbyggnad",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Genomarbetat språk 2) Träffsäkra ordval 3) Utvecklat bildspråk",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Enkla ordval 3) Mestadels korrekt",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Variation 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Beskrivande text",
		grade: "firstRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Sinnesintryck och detaljer",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fem sinnen effektivt 2) Stilistiskt säkra adjektiv 3) Avancerade detaljer 4) Originella bildspråk",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fyra sinnen 2) Träffsäkra adjektiv 3) Utvecklade detaljer 4) Fungerande bildspråk",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tre sinnen 2) Enkla adjektiv 3) Tydliga detaljer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sinnesintryck 2) Adjektiv 3) Detaljer",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Nyanserad miljöskildring 2) Psykologisk persongestaltning 3) Konsekvent stämning 4) Skickligt perspektivval",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad miljöbeskrivning 2) Fördjupad personbeskrivning 3) Tydlig stämning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande miljöbeskrivning 2) Enkel personbeskrivning 3) Viss stämning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Miljöbeskrivning 2) Personbeskrivning 3) Stämning",
					},
				],
			},
			{
				name: "Struktur och fokus",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Skarp fokus 2) Sex-åtta stycken 3) Effektiv disposition 4) Dynamiska övergångar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt fokus 2) Fem-sex stycken 3) Logisk disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande fokus 2) Fyra-fem stycken 3) Enkel disposition",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fokus 2) Styckeindelning 3) Disposition",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Stilistiskt säkert 2) Träffsäkra formuleringar 3) Kreativt bildspråk 4) Dynamisk meningsbyggnad",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Klart språk 2) Genomtänkta ordval 3) Utvecklat bildspråk",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Grundläggande ordval 3) Viss variation",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Språklig säkerhet 2) Variation 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Beskrivande text",
		grade: "secondRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Sinnesintryck och detaljer",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fem sinnen kreativt 2) Stilistiskt avancerade adjektiv 3) Komplexa detaljer 4) Nyskapande bildspråk",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fyra-fem sinnen 2) Precisa adjektiv 3) Utvecklade detaljer 4) Genomtänkt bildspråk",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tre-fyra sinnen 2) Fungerande adjektiv 3) Tydliga detaljer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sinnesintryck 2) Adjektiv 3) Detaljer",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Komplex miljöskildring 2) Djupgående persongestaltning 3) Genomarbetad stämning 4) Effektfullt perspektiv",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Nyanserad miljöbeskrivning 2) Utvecklad persongestaltning 3) Genomgående stämning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydlig miljöbeskrivning 2) Grundläggande persongestaltning 3) Viss stämning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Miljöbeskrivning 2) Persongestaltning 3) Stämning",
					},
				],
			},
			{
				name: "Struktur och fokus",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Precist fokus 2) Sju-nio stycken 3) Avancerad disposition 4) Eleganta övergångar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Genomgående fokus 2) Sex-sju stycken 3) Utvecklad disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydligt fokus 2) Fem-sex stycken 3) Logisk disposition",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fokus 2) Styckeindelning 3) Disposition",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Stilistiskt skickligt 2) Precisa formuleringar 3) Avancerat bildspråk 4) Komplex meningsbyggnad",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Säkert språk 2) Träffsäkra ordval 3) Utvecklat bildspråk",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Genomtänkta ordval 3) Viss variation",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Språklig säkerhet 2) Variation 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Beskrivande text",
		grade: "thirdRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Sinnesintryck och detaljer",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fem sinnen litterärt 2) Konstnärligt valda adjektiv 3) Subtila detaljer 4) Sofistikerat bildspråk",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fyra-fem sinnen effektivt 2) Träffsäkra adjektiv 3) Nyanserade detaljer 4) Utvecklat bildspråk",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fyra sinnen 2) Precisa adjektiv 3) Tydliga detaljer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sinnesintryck 2) Adjektiv 3) Detaljer",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Litterär miljöskildring 2) Psykologiskt djup 3) Konstnärlig stämning 4) Sofistikerat perspektiv",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Komplex miljöskildring 2) Utvecklad persongestaltning 3) Genomarbetad stämning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Nyanserad miljöbeskrivning 2) Tydlig persongestaltning 3) Genomgående stämning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Miljöskildring 2) Persongestaltning 3) Stämning",
					},
				],
			},
			{
				name: "Struktur och fokus",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Konstnärligt fokus 2) Åtta-tio stycken 3) Sofistikerad disposition 4) Litterära övergångar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Precist fokus 2) Sju-åtta stycken 3) Avancerad disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Genomgående fokus 2) Sex-sju stycken 3) Utvecklad disposition",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fokus 2) Styckeindelning 3) Disposition",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Litterärt språk 2) Sofistikerade formuleringar 3) Konstnärligt bildspråk 4) Retorisk medvetenhet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Stilistiskt säkert 2) Precisa ordval 3) Avancerat bildspråk",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Säkert språk 2) Träffsäkra ordval 3) Utvecklat bildspråk",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Språklig säkerhet 2) Precision 3) Bildspråk",
					},
				],
			},
		],
	},
];
